<template>
  <v-container>
    <v-btn
      v-if="isValidToken == true"
      class="m-5"
      color="primary"
      @click="generatePdf"
      >Télécharger / Download
    </v-btn>

    <v-container
      v-if="isValidToken == true"
      id="receptHtml"
      style="max-width: 800px"
      ref="receptHtml"
      fluid
      fill-height
    >
      <v-layout align-center justify-center>
        <div class="navbar-toggler body"></div>
        <v-flex>
          <v-row id="">
            <v-col cols="2" md="2">
              <img id="img-flag" v-bind:src="flag"
            /></v-col>
            <v-col class="text-center" cols="8"
              ><h5>République du Cameroun</h5>

              <h5>Republic of Cameroun</h5>
            </v-col>
            <v-col cols="2" md="2">
              <img id="img-logo" v-bind:src="logo" />
            </v-col>

            <v-col class="text-center" cols="12" md="12">
              <h3>Pé-enroulement approuvé/ Approved pre-enrolment</h3>
              <h5>Identité du demandeur/ Identity of applicant</h5>
            </v-col>
            <v-col cols="12">
              <v-row cols="10" justify="space-around">
                <v-col class="text-left" cols="12" md="7">
                  <span class="h6_span"> Nom/Name : {{ demand.nom }} </span>
                  <br />
                  <span class="h6_span">
                    Date de naissance/Date of birth : {{ demand.birthdate }}
                  </span>
                  <br />
                  <span class="h6_span">
                    N° Titre de voyage /Passport number :{{
                      demand.passportnumber
                    }}
                  </span>
                  <br />
                  <span class="h6_span">
                    Approuvé le/ Approved :{{ demand.approuved_date }} </span
                  ><br />
                </v-col>

                <v-col style="" class="text-left" cols="12" md="5">
                  <span class="h6_span">
                    Prénom/ Given Name :{{ demand.prenom }}
                  </span>
                  <br />
                  <span class="h6_span"
                    >Lieu de naissance / Place of birth :
                    {{ demand.birthcountry }}
                  </span>
                  <br />
                </v-col>
              </v-row>
            </v-col>

            <v-col class="text-center" cols="12" md="12"
              ><h4>Référence de l'enregistrement/ Registration reference</h4>
              <div id="qr-code">
                <qr-code
                  :text="JSON.stringify(demand.code_demande)"
                  :size="100"
                ></qr-code>
              </div>
              <br />
              <h4>{{ demand.code_demande }}</h4>
              <br />
            </v-col>
            <v-col cols="12" class="text-center">
              <h5 class="text--black font-weight-bold">
                Prier de présenter ce document au post d'enregistrement au point
                d'entré
              </h5>
              <h5 class="text--black font-weight-bold">
                Please present this document to the registration post at the
                point of entry
              </h5>

              <br />
              <h6 class="red-texte">
                Ce documment est une pré-authorisation de visa d'entrée au cameroun
              </h6>
              <h6 class="red-texte">
               This document is a pre-authorization for entry visa to Cameroon
              </h6>
            </v-col>

            <div id="movetop"></div>
          </v-row>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container v-if="isValidToken == false" fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex>
          <v-row class="text-center">
            <v-card width="500" class="mx-auto" style="border: solid 2px gray">
              <v-card-text>
                <div
                  style="
                    font-weight: 800;
                    color: red !important;
                    margin-top: 100px;
                    margin-bottom: 50px;
                  "
                >
                  <h4 style="font-weight: 800; color: red" class="mx-auto">
                    Token invalid !
                  </h4>
                </div>
                <div
                  style="
                    margin-top: 50px;
                    margin-bottom: 50px;
                    font-weight: 800;
                  "
                >
                  <v-icon color="red" size="100px"> mdi-emoticon-sad </v-icon>
                </div>
              </v-card-text>
            </v-card>
          </v-row>
        </v-flex>
      </v-layout>
    </v-container>
  </v-container>
</template>

<script>
import moment from "moment";
import flag from "../../public/cam_flag.png";
import logo from "../../public/flag_logo1.png";
import html2pdf from "html2pdf.js";
import VueQRCodeComponent from "vue-qrcode-component";
import { mapGetters } from "vuex";

export default {
  name: "RegisterRecept",

  components: {
    "qr-code": VueQRCodeComponent,
  },
  props: {},
  data() {
    return {
      isValidToken: null,
      demand: null,
      codeDemnde: null,
      flag: flag,
      logo: logo,
      languages: [
        { id: 0, name: "fr", flag: "fr", langue: "Français" },
        { id: 1, name: "en", flag: "us", langue: "English" },
      ],
      courseId: null,
    };
  },

  created() {
    this.token = this.$route.params.id;
    this.$store.dispatch("setCurrentRoute", this.$route.name);
    moment.locale(this.langLocal);
  },
  mounted() {
    this.initialize();
  },
  computed: {
    ...mapGetters(["authenticated", "langLocal", "isdark"]),
  },
  methods: {
    format_date(value, format) {
      if (value) {
        return moment(String(value)).format(format);
      }
    },

    changeLanguage(id) {
      this.$store.dispatch("setlanguage", this.languages[id]["name"]);
    },
    async initialize() {
      const formdata = new FormData();
      formdata.append("token", this.token);
      await this.$store
        .dispatch("getInfoTokenApproved", formdata)
        .then((response) => {
          if (response.code_demande) {
            this.codeDemnde = response.code_demande
            let item = {
              code_demande: response.code_demande,
              nom: response.nom,
              birthdate: this.format_date(response.birthday, "MM/DD/YYYY"),
              prenom: response.prenom,
              birthcountry: response.birth_country,
              passportnumber: response.numpasseport,
              type_visas: response.type_visas,
              approuved_date: this.format_date(
                response.updated_at,
                "MM/DD/YYYY HH:mm:ss"
              ),
            };
            this.demand = item;
            this.isValidToken = true;
            this.generatePdf()
          } else {
            this.isValidToken = false;
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error);
        });
    },

    //jspdf does not include the bootstrap style layout
    generatePdf() {
      var element = this.$refs.receptHtml;
      var opt = {
        margin: 0.1,
        filename: "PreApprouved_" + this.codeDemnde + ".pdf",
        image: { type: "jpeg", quality: 1 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      };
      html2pdf().from(element).set(opt).save();
    },
  },
};
</script>
<style scoped>
.h6_span {
  font-weight: 400 !important;
  font-family: "Lato", Arial, sans-serif !important;
  color: #000 !important;
  font-size: 0.75em !important;
}

#receptHtml {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;

  padding: 30px;
  border-style: solid;
  border-color: black;
}
.light-text {
  font-size: 16px;
  font-weight: 100;
}
#site-header {
  margin-bottom: 100px;
}
#fixed-header {
  box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.5);
}
.no-space {
  padding: 0px !important;
  margin: 0px !important;
}
.div-lang {
  background-color: rgb(37, 51, 114);
  height: 50px;
  padding: 0px;
}

.divider {
  border-color: white !important;
}
#qr-code {
  margin: auto !important;
  width: fit-content;
}
.red-texte {
  color: red;
}
#img-logo {
  width: 120px;
  height: 80px;
  border-radius: 3px;
}
#img-flag {
  width: 120px;
  height: 80px;
  border-radius: 3px;
}
@media (max-width: 990px) {
  #img-logo {
    width: 50px;
    height: 50px;
  }
  #img-flag {
    width: 50px;
    height: 50px;
  }
}
</style>
